// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Podatkovni Trg",
        "pull_refresh": "Premikni dol za osvežitev",
        "release_refresh": "Sprostitev za osvežitev",
        "refresh_loading": "Nalaganje ...",
        "footer_text": "Storitve ponuja Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Država/regija iskanja",
        "my_flow": "Moji podatki",
        "charge_code": "Koda bona",
        "coupons": "Kuponi",
        "local_package": "Lokalni podatki",
        "more": "Več",
        "popular_destination": "Država/regija",
        "buy_now": "Kupi zdaj",
        "package_useing": "Aktivno",
        "unused": "Neaktivno",
        "download_app": "Prenesite APP",
        "enter_the_mall_list": "Vstopite v nakupovalni center",
        "no_data": "Ni podatkov",
        "no_data_available": "Ni na voljo podatkov",
        "copy_success": "Kopiranje je uspelo",
        "copy_fail": "Kopiranje ni uspelo",
        "meritsTitle": "Katere so prednosti?",
        "merits1": "Brez SIM kartice & Brez mesečnih stroškov",
        "merits2": "Integracija z vrhovskimi 2-3 operaterji za avtomatsko spreminjanje mreže",
        "go_buy": "Kupi zdaj",
        "instant_savings": "Prihrani",
        "expires_in": "Poteče čez",
        "download_app_tips": "Prenesite aplikacijo za več ponudb in izkušenj"
    },
    "packages": {
        "sub_title": {
            "us": "Razen Guama, Saipan",
            "it": "Vključno z Vatican Cityjem, San Marino",
            "va": "Vključno z Italijo, San Marino",
            "sm": "Vključno z Italijo, Vatikanom",
            "ma": "Vključno z zahodno Saharo",
            "eh": "Vključno z Marokom",
            "ch": "Vključno z Liechtensteinom",
            "li": "Vključno s Švico",
            "fr": "Vključno z Monakom",
            "mc": "Vključno s Francijo",
            "fi": "Vključno z Alandskimi otoki",
            "ax": "Vključno s Finsko",
            "gu": "Vključno z otoki Severne Mariane",
            "mp": "Vključno z Guamom"
        },
        "unlimited_packages": "Neomejen podatkovni paket",
        "normal_packages": "Običajni podatkovni paket",
        "multi_region_packages": "Večregion",
        "regional_data": "Regijski podatki",
        "high_speed_text": "Podatki o visoki hitrosti",
        "infiniteFlow": "Neomejeni podatki",
        "unLimitData": "Neomejen",
        "high_speed_text_year": "visoka hitrost/mp",
        "package_list": "Seznam paketov",
        "special_offer": "Popusti",
        "first_month": "1. Mesec",
        "periodUnit": {
            "day": "Dan",
            "month": "mesec",
            "hour": "Ura",
            "year": "leto"
        },
        "periodUnits": {
            "day": "Dan",
            "month": "meseci",
            "hour": "Ura",
            "year": "leta"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "za",
            "hour": "h",
            "year": "yr"
        },
        "periodUnitMonthly":"Mesečni",
        "periodUnitsSimp": {
            "day": "d",
            "month": "za",
            "hour": "h",
            "year": "yr"
        },
        "unlimited_good_name": {
            "day": "Dnevni prehod",
            "month": "Mesečna vozovnica",
            "year": "Letno prehodno"
        },
        "continuousMonth": "Neprekinjeni meseci",
        "continuousDay": "Neprekinjeni dnevi",
        "continuousYear": "Neprekinjena leta",
        "day_invalid": "Iztečejo se na trenutni dan",
        "month_invalid": "Izteče v tekočem mesecu",
        "immediate_valid": "Takoj učinkovito",
        "tomorrow_day_valid": "Učinkovito od naslednjega dne",
        "tomorrow_month_valid": "Velja od naslednjega meseca",
        "detail": {
            "cell_flow": "Podatki",
            "cell_period": "Veljavnost",
            "buy_quantity": "Znesek",
            "use_area": "Pokritost",
            "use_intro": "Pogoji",
            "buy_btn": "Vrstni red",
            "pay": "Plačati",
            "buy_tips": "Imate paket %@packageName v uporabi. Ali želite kupiti ta paket?",
            "haveOrderTips": "Ustvarjena naročila z čakajočo plačilom. Kliknite Potrdi za dostop do moje strani podatkov！"
        },
        "confirm": {
            "title": "Potrditev naročila",
            "real_pay_amount": "Plačan znesek",
            "online_payment": "Spletno plačilo",
            "create_order_error": "Nastavitev ni uspela"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Pridobivanje stanja naročila ...",
            "buy_success": "Naročilo dokončano",
            "buy_pending": "Do potrditve",
            "buy_pending_tip": "Plačilo v postopku… Če plačila ne bo preneseno v 10 minutah, nas kontaktirajte za podporo.",
            "get_payment_info_fail": "Nakup informacij o plačilu ni uspelo",
            "cell_package": "Paket",
            "cell_buy_amount": "Podtotalno",
            "cell_real_amount": "Plačan znesek",
            "go_to_order_btn": "Pojdi v moj paket",
            "back_home": "Nazaj domov",
            "back_mall": "Nazaj v center",
            "ordersn_empty": "Naročilo sn ne more biti prazen",
            "order_search_error": "Nepričakovana napaka",
            "goodsName": 'Ime izdelka'
        },
        "fail": {
            "payment_fail": "Plačilo ni uspelo",
            "back_home": "Nazaj domov"
        }
    },
    "CountryGroup": {
        "title": "Država/regija",
        "placeholder": "Država iskanja ali regija",
        "clear": "Jasno",
        "history": "Zgodovina iskanja"
    },
    "PromotionCode": {
        "verification": {
            "title": "Koda bona",
            "minititle": "Koda bona",
            "input": "Vnesite kodo za dopolnjevanje",
            "explain": "Nasveti: Dotaknite se gumba za skeniranje v zgornjem desnem desnem desnem kotu, da skenirate QR kodo kartice bona ali ročno vnesete kodo bona (občutljivo na primer), če ne deluje.",
            "submit": "Oddaj",
            "exchange": "Odkup",
            "cancel": "Odpovedati",
            "Inquiry": "Ali ste zagotovo izmenjali",
            "ErrorCode": "Napaka kode napolnite"
        },
        "recharge_success": {
            "package": "Paket",
            "content": "Uspešno unovčen",
            "back": "Nazaj v nakupovalni center",
            "view_packets": "Pojdi v moj paket"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktivirano",
            "isFirst": "Prednostno",
            "toFirst": "Nastavi prednostno nalogo",
            "inactive": "Neaktivirano"
        },
        "periodUnits": {
            "minute": "minute",
            "hour": "Ura",
            "day": "Dan",
            "month": "Mesec"
        },
        "useIntro": {
            "tip1": "Neomejen podatkovni paket ima večjo prioriteto kot paket podatkov o glasnosti.",
            "tip2": "Prioriteta uporabe bo temeljila na datumu nakupa za isto vrsto paketa, tj. Paket z najzgodnejšim datumom nakupa bo najprej porabljen, medtem ko je prednostna naloga paketov z eno regijo višja od regionalnega paketa.",
            "tip3": "Prav tako lahko ročno prilagodite prednostno nalogo uporabe paketov iste vrste."
        },
        "myFlow": "Moji podatki",
        "remainingFlow": "Podatki ostanejo",
        "remainingTime": "Veljavno levo",
        "remainingHighFlow": "Ostavljeni podatki za visoke hitrosti",
        "validPeriod": "Veljavnost",
        "noneFlow": "Ni podatkovnega paketa",
        "noneFlowTip": "Prosimo, kupite podatkovni paket in uživajte v visoko kakovostnem omrežju",
        "buyPackFlow": "Kupiti pakete",
        "checkInvalidFlow": "Preverite podatkovni paket",
        "orderList": {
            "title": "moja naročila",
            "amount_paid": "Skupaj",
            "device": "Naprava v lasti",
            "order_details": "Podrobnosti naročila",
            "total_amont": "Vmesni seštevek",
            "orderSN": "Naročilo št.",
            "createTime": "Čas ustvarjanja",
            "cancelTime": "Zaprt čas",
            "payTime": "Čas naročila",
            "unsubTime": "Odpovedan čas",
            "payMethod": "Način plačila",
            "thirdSN": "Transakcija št.",
            "delete": "Izbriši",
            "cancel": "Prekliči naročilo",
            "unsub": "Povračilo",
            "goto_cancel": "Ali želite preklicati naročilo?",
            "goto_unsubscribe": "Ali želite odjaviti naročilo?",
            "delete_Tips": "Po izbrisu naročila ni mogoče nadaljevati, zato vaših težav po storitvi ni mogoče obravnavati.Ste prepričani, da ga želite izbrisati?",
            "status_success": "Dokončano",
            "status_pending": "Neplačano",
            "status_cancel": "Zaprto",
            "status_unsub": "Preklicano",
            "payMethod_stripe": "Kreditna kartica"
          },
    },
    "registerlogin": {
        "create_account_tip":"Ustvari račun, začnite ekskluzivno izkušnjo",
        "select_country_tip":"Država/regija naprave",
        "email_name": "Pošta",
        "phone_name": "Telefon",
        "email_address": "E -poštni naslov",
        "password": "geslo",
        "country": "država",
        "select_country": "Izberite državo",
        "cancel": "Odpovedati",
        "confirm": "Zagotovo",
        "please_enter": "Vnesite 6-20 znakov (kombinacija črk, številk ali simbolov)",
        "select_country_tips": "Izbira držav je za ogled lokalnih paketov. Po registraciji ga ni mogoče spremeniti. Prosim, potrdite!",
        "global_roaming": "Mednarodna domenska koda",
        "phone_number": "telefonska številka",
        "agree": "se strinjam",
        "user_agreement": "Uporabniška pogodba",
        "and": "in",
        "privacy_policy": "Politika zasebnosti",
        "register_login": "Prijavite se ali se prijavite",
        "login_error": "Število prijav je prepogosto, poskusite znova kasneje!",
        "register_error": "Število registracij je prepogosto, poskusite znova kasneje!",
        "forgot_pwd": "Pozabite na geslo",
        "app_tips": "Po prenosu tega računa se prijavite v aplikacijo s tem računom, da dostopate do več funkcij.",
        "download_app": "Pojdite na prenos aplikacije",
        "rememberPwd": "Ne pozabite na geslo",
        "third_login": "Nadaljujte z",
        "agreement_tips": "Preverite polje Sporazuma o uporabniku in pravilniku o zasebnosti",
        "selectCountry_tips": "Prosimo, upoštevajte, da bo registrirana država neposredno vplivala na naslednje načine plačila in valute, izberite glede na vaše potrebe.",
        "login_error_cancel": "Uporabnik je preklical prijavos",
        "login_error_auth": "Dovolite pojavne okna v nastavitvah brskalnika",
        "device_tips": "Napaka čaka aktivacijo. Obdelava v 24 urah."
    },
    "forgotPwd": {
        "forgot_pwd": "Pozabite na geslo",
        "email_address": "E -poštni naslov",
        "next": "Naslednji",
        "email_has_been_sent": "Poslali smo e-pošto na %@email. Kliknite na povezavo in sledite korakom za pridobitev gesla.",
        "have_retrieved_it": "Našel sem ga",
        "unable_to_receive_email": "Ne morete prejeti e-pošte? Preverite, ali so v mapi z neželeno pošto in izbrisano pošto e-poštna sporočila od %@email.",
        "or": "ali",
        "resend": "Ponovni",
        "global_roaming": "Mednarodna domenska koda",
        "phone_number": "telefonska številka",
        "verification_code_has_been_sent": "Kodeks preverjanja smo poslali v:",
        "verification_code": "Koda za preverjanje",
        "no_verification_code_received": "Niste prejeli kode za preverjanje?",
        "please_enter": "Vnesite 6-20 znakov (kombinacija črk, številk ali simbolov)",
        "reset_password": "Ponastavitev gesla",
        "reset_successful": "Uspešno ponastaviti"
    },
    "coupons": {
        "coupons_name": "Kuponi",
        "no_coupons": "Še ni kuponov",
        "no_data": "Še ni podatkov",
        "applicable_to_the_following": "Kuponi so primerni za naslednji podatkovni paket"
    },
    "digital":{
        "title":"Naprava SN",
        "purchased":"Moji nakupi",
        "viewAll":"Več",
        "skinStore":"Trgovina izdelkov",
        "completed":"Kupljeno",
        "goBuy":"Kupite",
        "order": {
          "title":"Kupljena naročila"
        },
        "detail": {
          "describe":"Opis"
        }
    },
    "viewPL": {
        "other": 'drugi'
    },
    "invalidFlow": {
        "stateName": "Status",
        "state": {
            "NOT_ACTIVATED": "Neaktivirano",
            "IN_USING": "Na voljo",
            "USE_END": "Izčrpan",
            "EXPIRE": "Poteklo",
            "TRANSFER": "Prenos",
            "UNSUBSCRIBE": "Odpovedati",
            "VALID": "Veljaven",
            "INVALID": "Neveljaven",
            "EXCHANGE_POINTS": "Odkup točk",
        },
        "noneFlow": "Brez iztekanega podatkovnega paketa",
        "pageName": "Poteklo podatkovni paket"
    },
    "flowDetail": {
        "title": "Podrobnosti o podatkih",
        "flow": "Podatki",
        "validTime": "Veljavni začetki",
        "invalidTime": "Veljavno do",
        "coverage": "Pokritost",
        "useIntro": "Pogoji",
        "purchaseTime": "Kupljeno na",
        "subtotal": "Podtotalno",
        "status": "Status",
        "cancel": "Odpovedati",
        "buyAgain": "Kupite še enkrat",
        "validity": "Veljavnost",
        "tip": "Obvestilo",
        "cancelTip": "Ali ste prepričani, da želite ta paket povrniti?",
        "dataLeft": "Podatki ostanejo",
    },
    "netError": {
        "try_again": "Poskusite znova",
        "net_error": "Brez omrežja",
        "try_again_desc": "Preverite nastavitev omrežja in poskusite znova"
    },
    "loadFail": {
        "try_again": "Poskusite znova",
        "load_fail": "Nalaganje ni uspelo",
        "load_fail_desc": "Nalaganje podatkov ni uspelo, poskusite znova",
        "IMEI_Not_Exist": "IMEI ne obstaja, poskusite vstopiti s pravega vhoda",
        "Project_Not_Exist": "Pride do napake. Obrnite se na službo za stranke. (01)",
        "commonError": "Pride do napake. Obrnite se na službo za stranke."
    },
    "settlement_Easy_and_convenient": "Enostavno in priročno",
    "settlement_Great_deal": "Veliko",
    "settlement_Safe_and_secure": "Varen in varen",
    "settlement_Autopay_service_regulation": "Uredba o samodejnih programih",
    "settlement_Read": "Preberite",
    "settlement_No_coupon": "Ni na voljo kupona",
    "settlement_Subtotal": "Podtotalno",
    "settlement_Coupon": "Kuponi",
    "settlement_TOTAL": "Skupaj",
    "settlement_promotion_tip": "Promocijske ponudbe ni mogoče uporabiti skupaj s kuponi",
    "settlement_coupon_tip": "Kupona ni mogoče uporabiti v povezavi z drugimi promocijskimi ponudbami",
    "member_myFlow_noList": "Brez podatkov~",
    "detail_se_content": "Varen, enostaven in priročen način. Kadar koli se lahko odjavite",
    "Enter_Promo_code": "Promocijska koda",
    "Enter_Promo_Coupon": "Kuponi",
    "settlement_Not_used_coupon": "kupon ni uporabljen",
    "settlement_Available_coupon": "Na voljo",
    "settlement_Unavailable_coupon": "Ni na voljo",
    "please_Enter_Promo_code": "Prosimo, vnesite promocijsko kodo",
    "please_Select_Coupon_use": "Izberite kupon, ki ga želite uporabiti.",
    "Buy_Now": "Kupi zdaj",
    "Dont_Use_Any": "Ne uporabljajte nobenega",
    "settlement_confirm": "Potrdite",
    "settlement_tips": "Potrdite",
    "flowDetail_unsubscribe":"Odjava",
    "flowDetail_unsubscribed": "Odpisano",
    "flowDetail_isCancelPackage":"Odjavite ta paket?",
    "flowDetail_confirmAgreementUnsubscribe":"Po odjavi ne morete imeti velikega dela. Ste prepričani, da se želite odjaviti?",
    "flowDetail_cancel": "Odpovedati",
    "flowDetail_cancelSuccess":"Uspešno odjavite",
    "packages_detail_promotion": "Proti",
    "orderTips":{
        "iDay" : "dan",
        "iDays" : "dnevi",
        "iMonth" : "mesec",
        "iMonths" : "meseci",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol na prvem nakupu, Kasneje plačajte %@money/%@periodSymbol, Kadar koli se lahko odjavite",
        'Monthly_discount':"Prihranite %@saveMoney vsak %@period! Kadar koli se lahko odjavite",
        'Ordinary_monthly_package':"Varen, enostaven in priročen način. Kadar koli se lahko odjavite",
        "AlreadyPurchased":'Žal se lahko trenutno naročite samo na en podatkovni paket. Prosimo, odjavite se od “%@” in se po izteku njega naročite na kateri koli paket, ki si ga želite.',
        "Contract_recommendation_First":'<label>S storitvijo AutoPay, pri prvem nakupu, plačajte samo</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Kadar koli se lahko odjavite'
        +'<a class="btn">Naročite se ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>S storitvijo AutoPay, plačajte samo</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Kadar koli se lahko odjavite'
        +'<a class="btn">Naročite se ></a></p>',
        "Contract_recommendation_General":"<label>S storitvijo AutoPay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Varen, enostaven in priročen način. Kadar koli se lahko odjavite'
        +'<a href="javascript:;" class="btn">Naročite se ></a></p>',
        'BanlanceDoubleCheck':'Ste prepričani, da želite plačati z bilanco?',
    },
    feedback: {
        title: "povratne informacije",
        placeholder: "Prosimo, vnesite državo, ki jo želite obiskati, ali kakršna koli druga vprašanja, in čim prej bomo izpolnili vaše potrebe!",
        submit: "Predložite",
        submit_success: "Uspešno predložite",
        other_opinions: "Druge mnenja"
    },
    view_country_input: 'Prosim vnesite svoj račun',
    "select_package": {
        "title": "Izberite Podatke",
        "allPackage": "Vsi Podatki",
        "type": "Tip",
        "flow": "Podatki",
        "month_package": "Mesečni načrt",
        "flow_package": "Podatkovni paket",
        "time": "Trajanje",
        "period": "Ciklus",
        "auto_debit": "Info Avtodebet",
        "auto_subscribe": "Auto-Obnavljanje",
        "detail": "Podrobnosti Podatkov",
        "carrier": "Podprti Operaterji",
        "country": "Pokrite Države",
        "notice": "Vodenje za nakup"
    }
}